module.exports = __webpack_public_path__ + "img/tiankang2.c1d91bb9.jpeg";